import type { SearchMetadataKind } from '../models'

export const searchQueryKeys = {
  /** A table's search: it covers the whole table whatever view is open. */
  search: (tableId: string, query: string, matchParams?: unknown) =>
    ['search', tableId, query, matchParams ?? {}] as const,
  searchGlobal: (query: string, matchParams?: unknown) =>
    ['search-global', query, matchParams ?? {}] as const,
  searchPreview: (hydrate = false) => ['search-global-preview', { hydrate }] as const,
  searchPreviewAll: ['search-global-preview'] as const,
  /** A global-search metadata section's "See more" pages, after the response's own rows. */
  globalSearchPages: (section: SearchMetadataKind, query: string, matchParams?: unknown) =>
    ['search-global-pages', section, query, matchParams ?? {}] as const,
  /** One scrolled-to window of a metadata section on its own result tab. */
  globalSearchWindow: (
    section: SearchMetadataKind,
    query: string,
    matchParams: unknown,
    offset: number,
    limit: number
  ) => ['search-global-window', section, query, matchParams ?? {}, { offset, limit }] as const,
  /** The empty search's "See more" record pages. */
  previewRecordPages: ['search-preview-records', 'pages'] as const,
  /** One scrolled-to batch of the empty search's records on the Records tab. */
  previewRecordWindow: (offset: number, limit: number, total: number) =>
    ['search-preview-records', 'window', { offset, limit, total }] as const,
}
